var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextSlide({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 23,
    viewBox: "0 0 14 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.88546 11.2929L13.3328 19.7405C13.5654 19.9726 13.6933 20.2828 13.6933 20.6137C13.6933 20.9447 13.5654 21.2547 13.3328 21.4871L12.5926 22.227C12.3603 22.4598 12.0499 22.5879 11.7191 22.5879C11.3883 22.5879 11.0782 22.4598 10.8458 22.227L0.787927 12.1693C0.554595 11.9361 0.426822 11.6246 0.42774 11.2934C0.426822 10.9608 0.554411 10.6496 0.787927 10.4163L10.8364 0.368318C11.0688 0.135537 11.3789 0.00739575 11.7099 0.00739578C12.0407 0.00739581 12.3508 0.135537 12.5834 0.368318L13.3234 1.10815C13.8049 1.58968 13.8049 2.37358 13.3234 2.85493L4.88546 11.2929Z",
    fill: "#1D4EAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextSlide);
export default __webpack_public_path__ + "static/media/nextSlide.2a9c029d7376aec4f88de6abfcc19d47.svg";
export { ForwardRef as ReactComponent };